import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthservicesService } from 'src/app/services/authservices.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import * as moment from 'moment';
import 'moment-duration-format';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-video-manager',
  templateUrl: './video-manager.component.html',
  styleUrls: ['./video-manager.component.css']
})
export class VideoManagerComponent implements OnInit {
  arr = [1, 23, 4, 5]
  loading = false
  objArr = []
  sliderArr = []
  legecyArr = []
  imagePlaceholder = ""

  constructor(private authService: AuthservicesService, private router: Router, private sanitizer: DomSanitizer,
  ) { }

  ngOnInit(): void {
    this.getVideo();
  }



  getVideo() {
    this.sliderArr = []
    this.legecyArr = []
    this.authService.getVideo().subscribe((res: any) => {
      this.loading = true
      this.objArr = res.items
      console.log('%----------',this.objArr)
      this.objArr.forEach((e) => {
        if (e.isShown) {
          this.sliderArr.push(e)
        }
        else if (!e.isShown) {
          this.legecyArr.push(e)
          // console.log(this.legecyArr, " this.legecyArr");
        }
      })
    },
      error => {
        console.log(error)
        this.loading = true
      })
  }

  deleteVideo(id, key, i) {

    let swall = this.authService.swal('delete')

    swall.then((result) => {
      if (result.value == true) {
        this.authService.removeVideo({ videoId: id }).subscribe((res: any) => {
          this.authService.successMessage(res.message, 'success').then(res => {
            if (res.value) {
              if (key == 'slider') {
                setTimeout(() => {
                  this.sliderArr.splice(i, 1)
                }, 1000)

              }
              else if (key == 'legecy') {
                setTimeout(() => {
                  this.legecyArr.splice(i, 1)
                }, 1000)
              }
            }
          })
        },
          error => {
            this.authService.successMessage(error.error.message, 'error')
          })
      }
    })
  }


  transform(html: string) {
    return this.sanitizer.bypassSecurityTrustHtml(html)
  }


  // getMoment(value) {
  //   let data =  moment.duration(value, 'seconds').format('hh:mm:ss');
  // }

  getErrorImage(event, props) {

    if (props.videoType == 'Rumble') {
      event.target.src = environment.imagePlaceholders['Rumble']
    }
    if (props.videoType == 'Vimeo') {
      event.target.src = environment.imagePlaceholders['Vimeo']

    }
    if (props.videoType == 'Facebook') {
      event.target.src = environment.imagePlaceholders['Facebook']

    }


  }

  renderImage(data) {
    let imgUrl = (data.videoType == 'Youtube') ? data.thumbnailUrl : this.authService.spilturl(data.channelThumbnailUrl)
    return imgUrl
  }



  navigate(id) {
    this.router.navigate(['/video-manager/update-video', id])
  }
}
